export const ja = {
  appTitle: 'ラッキーどうぶつ ナワバリ',
  help: 'あそびかた',
  helpAria: 'あそびかた',
  settings: 'せってい',
  settingsAria: 'せってい',
  close: '閉じる',
  closeAria: '閉じる',
  player: 'プレイヤー',
  highscore: 'ハイスコア',
  start: 'ゲームスタート',
  staminaEmpty: 'スタミナがたりません',
  ranking: 'みんなのナワバリ戦',
  difficultyTitle: '難易度を選ぼう',
  difficultyStart: 'この難易度ではじめる',
  back: '戻る',
  today: '今日',
  weekly: '今週',
  alltime: '総合',
  loading: '読み込み中...',
  noScores: 'まだ戦績がありません。最初のナワバリ王になろう！',
  loadFailed: '取得に失敗しました',
  you: 'あなた',
  youConstant: 'YOU',
  language: '言語',
  languageNote: '日本語を含む18言語に対応しています。',
  bgm: 'BGM',
  se: '効果音',
  soundEnableAria: '音を出す',
  soundDisableAria: '音を消す',
  adWatch: '広告を最後まで見る',
  adCancel: 'やめておく',
  rankSuffix: '位',
  earnedPoints: 'が {score}pt を獲得',
  helpGoalTitle: '🎯 ゲームの目的',
  helpGoalText: '9×9 の盤面に交互にコマを置き、ナワバリ（自色の塊）を広げます。最終的にスコアの高いプレイヤーが勝ちです。',
  helpWinTitle: '🏆 勝利条件',
  helpWinFive: '縦・横・斜めに同じ色で 5 連そろえたら即勝利',
  helpWinScore: '盤面が満杯になったらスコア比較（引き分けなし）',
  helpScoreTitle: '💯 スコアのつきかた',
  helpLineBonus: 'ライン連数ボーナス: 3 連・4 連・5 連ができるたびに加点',
  helpClusterBonus: 'ナワバリ（クラスタ）ボーナス: 自色のコマがつながった塊のサイズに応じて加点',
  helpKomi: 'コミ: 後手側にスコア +10% のハンデポイント',
  helpControlsTitle: '🖱️ 操作',
  helpControlsText: '自分の手番で、盤面の空いているマスをタップするとコマを置けます。',
  helpTipsTitle: '💡 ヒント',
  helpTipHell: '腕試しには最難の HELL に挑戦',
  helpTipCluster: '5 連を狙うだけでなく、塊を広げるとスコアが伸びやすい',
  resultWinFive: '🎉 5連達成！あなたの勝ち！',
  resultWinScore: '🎉 スコア勝ち！あなたの完勝！',
  resultLoseFive: '😿 CPUが5連...完敗！',
  resultLoseScore: '😿 スコア負け...次こそ！',
  resultDraw: '🤝 引き分け',
  newHighscore: '🏆 ハイスコア更新！',
  scoreNone: 'スコアなし',
  clusterBonus: '塊ボーナス',
  retry: 'もういちど',
  titleBack: 'タイトルへ',
  scoreHintPlaceStone: '石を置こう',
  best: 'Best',
  clusterUnit: '塊',
  lineCount: '{len}連×{count}',
  turnCount: '{count}手目 · {difficulty}',
  boardPlayerPiece: 'あなたの駒',
  boardCpuPiece: 'CPUの駒',
  boardPlayerAlt: 'あなた',
  boardCpuAlt: 'CPU',
  boardCellPosition: '行{row}列{col}',
  boardPlaceable: '置けます',
  boardEmpty: '空きマス',
  boardFlower: '花あり',
  firstPlayerAlt: '先手',
  playerFirst: 'あなたが先手！',
  playerSecond: 'あなたは後手（+{bonus}% コミ付き）',
  cpuFirst: 'CPUが先手！',
  finalePlayerWin: 'あなたの勝ち！',
  finaleCpuWin: 'CPUの勝ち！',
  finaleFive: '5連達成！',
  finaleTerritory: 'ナワバリ勝負！',
  winnerAlt: '勝者',
  loadingBoot: '起動中...',
  loadingConnect: '接続中...',
  loadingProfile: 'プロフィールを読み込み中...',
  loadingAssets: 'アセットを読み込み中...',
  loadingReady: '準備完了',
  reauthRequiredTitle: '再ログインが必要です',
  startupFailedTitle: '起動に失敗しました',
  reauthButton: '再ログイン',
  reloadButton: '再読み込み',
  lineReloginButton: 'LINE 再ログイン',
  reauthReason: '認証の有効期限が切れました。もう一度ログインしてください。',
  errorReauth: '認証の有効期限が切れました。再度ログインしてください。',
  errorForbidden: 'このゲームを利用する権限がありません。',
  errorNotFound: 'ゲームデータが見つかりませんでした。',
  errorRateLimited: '通信が集中しています。しばらく待ってからお試しください。',
  errorServer: 'サーバーに接続できませんでした。時間をおいて再読み込みしてください。',
  errorCommunication: '通信エラーが発生しました。再読み込みしてください。',
  errorNetwork: 'ネットワークに接続できませんでした。電波状況を確認して再読み込みしてください。',
  errorStartup: '起動に失敗しました。再読み込みしてください。',
  settingsTabGeneral: '設定',
  settingsTabAccount: 'アカウント',
  settingsTabInfo: '情報',
  account: 'アカウント',
  linked: '連携済み',
  guest: 'ゲスト',
  loggedInWith: '{provider} アカウントでログイン中',
  loggedIn: 'アカウントでログイン中',
  playingAsGuest: '現在はゲストとしてプレイ中です。',
  appleLoginBusy: 'Apple ログイン中...',
  appleLogin: 'Apple でログイン',
  googleLoginBusy: 'Google ログイン中...',
  googleLogin: 'Google でログイン',
  logoutBusy: 'ログアウト中...',
  logout: 'ログアウト',
  logoutSuccess: 'ログアウトしました',
  logoutFailed: 'ログアウトに失敗しました',
  appInfo: 'アプリ情報',
  appName: 'アプリ名',
  version: 'バージョン',
  legalInfo: '法的情報',
  terms: '利用規約',
  privacy: 'プライバシーポリシー',
  operator: '運営者',
  contact: 'お問い合わせ',
  copyTap: 'タップでコピー',
  idCopied: 'IDをコピーしました',
  copyFailed: 'コピーに失敗しました',
  other: 'その他',
  reportAd: '不適切な広告を報告',
  privacyChoices: '広告プライバシー設定',
  profileEdit: 'プロフィール編集',
  displayName: '表示名',
  displayNamePlaceholder: '名前を入力',
  chooseIcon: 'アイコンを選ぶ',
  iconLoadFailed: 'アイコン一覧の取得に失敗しました。',
  saveFailed: '保存に失敗しました。再試行してください。',
  noIcons: '利用可能なアイコンがありません。',
  save: '保存',
  saving: '保存中...',
  staminaAria: 'スタミナ残量 {stamina} / {max}',
  nextRecovery: '次の回復まで {time}',
  adPlaying: '広告再生中...',
  recoverFullAd: '広告視聴でスタミナ全回復',
  dailyBonusAria: '広告を最後まで見るとスタミナ+5を受け取る',
  dailyBonusAd: '広告視聴でスタミナ+5',
  legalLastUpdated: '最終更新日: {date}',
  privacyTitle: 'プライバシーポリシー',
  termsTitle: '利用規約',
  adPlayingAria: '広告再生中',
  adBadge: '▶ 広告',
  adRemaining: '残り {seconds} 秒',
  adDevHint: '※ 開発用のダミー広告です。本番では実広告が再生されます。',
  adRewardRequirement: '広告を最後まで見ると、次の報酬を受け取れます。',
  adRewardStaminaDetail: '報酬: スタミナを最大値まで全回復',
  adRewardDailyBonusDetail: '報酬: 今日1回のボーナスとしてスタミナ +{amount}',
  adRewardIncompleteNote: '途中で閉じると報酬は受け取れません。',
  adSkipAria: '広告をスキップ',
  adSkip: 'スキップ ✕',
  adSkipAfter: 'スキップ（{seconds}秒後）',
  offlineMessage: 'サーバーに接続できません。一部の機能が利用できない可能性があります。',
  reconnecting: '再接続中...',
  reconnect: '再接続',
  signInTitle: 'サインイン',
  signInBusy: 'サインイン中...',
  signInCancelNote: 'サインインをキャンセルするとゲストのまま続行できます（一部機能は利用不可）。',
  processing: '処理中...',
  recoverConfirmTitle: 'データの上書き確認',
  recoverConfirmMessage: 'このログイン先には既存データがあります。続行すると、この端末で遊んでいたゲストデータは置き換わります。よろしいですか？',
  recoverConfirmContinue: '引き継ぐ',
  recoverConfirmCancel: 'キャンセル',
  unlinkConfirmTitle: '連携の解除',
  unlinkConfirmMessage: 'このプロバイダとの連携を解除すると、この端末ではゲストとしてプレイし直す形になります。\n他の端末で同じプロバイダから再ログインすれば、Hub 上のデータは残ります。',
  unlinkConfirmContinue: '解除する',
  unlinkConfirmCancel: 'キャンセル',
  deleteConfirmTitle: '退会の確認',
  deleteConfirmMessage: 'アカウントを削除すると、ハイスコア・ログイン情報・連携アカウント・招待関係がすべて失われます。\nこの操作は取り消せません。本当に退会しますか？',
  deleteConfirmContinue: '退会する',
  deleteConfirmCancel: 'キャンセル',
  adNekoTitle: 'ADねこ',
  matchmakingRemaining: '残り {seconds} 秒',
  matchmakingTimeoutMessage: '時間内に相手が見つかりませんでした。もう一度お試しください。',
  difficultyEasyName: 'おためし',
  difficultyEasyDescription: 'あいてはポヤッとしてるようだ',
  difficultyNormalName: 'ふつう',
  difficultyNormalDescription: 'あいてがたまにポカする',
  difficultyHardName: 'むずい',
  difficultyHardDescription: 'あいての視野がひろい',
  difficultyHellName: 'ヤバい',
  difficultyHellDescription: 'あいてがつよい 先読み上等',
} as const

export type TranslationKey = keyof typeof ja
export type TranslationDict = Record<TranslationKey, string>
